export default [
  {
    path: "/test",
    name: "test",
    component: () => import("@/views/lab/Test.vue"),
  },

  {
    path: "/add-test/:id",
    name: "add-test",
    component: () => import("@/views/lab/AddTest.vue"),
  },
  {
    path: "/group",
    name: "group",
    component: () => import("@/views/lab/Group.vue"),
  },
  {
    path: "/test-group",
    name: "test-group",
    component: () => import("@/views/lab/TestGroup.vue"),
  },
  {
    path: "/patient-test/",
    name: "patient-test",
    component: () => import("@/views/lab/PatientCardTest.vue"),
  },
  {
    path: "/patients-tests",
    name: "patients-tests",
    component: () => import("@/views/lab/PatientTests.vue"),
  },
  {
    path: "/patients-tests-details/:id",
    name: "patients-tests-details",
    component: () => import("@/views/lab/PatientTestDetails.vue"),
  },
  {
    path: "/single-test-details/:id/:patientCardId",
    name: "single-test-details",
    component: () => import("@/views/lab/SingleTestDetalis.vue"),
  },
  {
    path: "/patients-tests/Add",
    name: "patients-tests-AddNew",
    component: () => import("@/views/Reception/ReceptionAddNew.vue"),
  },
  {
    path: "/patients-lab",
    name: "patients-lab",
    component: () => import("@/views/lab/Patients.vue"),
  },
  {
    path: "/lab/unit",
    name: "unit-lab",
    component: () => import("@/views/lab/Unit.vue"),
  },
  {
    path: "/lab/lis-data",
    name: "lis-data",
    component: () => import("@/views/lab/LisData.vue"),
  },
  {
    path: "/hospital/vital-sign-types",
    name: "vital-sign-types",
    component: () => import("@/views/hospital/VitalSignTypes.vue"),
  },
  {
    path: "/lab/TestDevices",
    name: "test-devices",
    component: () => import("@/views/lab/TestDevices.vue"),
  },
  {
    path: "/lab/TestNormalRanges",
    name: "test-normal-ranges",
    component: () => import("@/views/lab/TestNormalRanges.vue"),
  },
  {
    path: "/lab/special-test-report",
    name: "special-test-report",
    component: () => import("@/views/lab/SpecialTestReport.vue"),
  },
  {
    path: "/lab/test-report-fields/:test_report_id/:test_report_name/:test_id/:test_name",
    name: "test-report-fields",
    component: () => import("@/views/lab/TestReportFields.vue"),
  },
  {
    path: "/lab/add-patient-to-test/:test_report_id/:test_report_name/:test_id/:test_name",
    name: "add-patient-to-test",
    component: () => import("@/views/lab/AddPatientToTest.vue"),
  },
  {
    path: "/lab/test-report-result",
    name: "test-report-result",
    component: () => import("@/views/lab/TestReportResult.vue"),
  },
];
